module.exports = __webpack_public_path__ + "img/fondo.56609958.png";